import { render, staticRenderFns } from "./EmptyIllustration.vue?vue&type=template&id=456cf4d4&scoped=true"
import script from "./EmptyIllustration.vue?vue&type=script&lang=js"
export * from "./EmptyIllustration.vue?vue&type=script&lang=js"
import style0 from "./EmptyIllustration.vue?vue&type=style&index=0&id=456cf4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456cf4d4",
  null
  
)

export default component.exports